// src/components/private/highgarden/purchased/Analytics.js
// Component to enable a user to select an option to see the offers

import React from 'react';
import PurchasedList from './PurchasedSavings';
import OptionSelector from '../../common_components/OptionSelector';
import ProductProductPrice from '../baseData/ProductProductPrice';


const options = [
    {
        icon: "bi bi-cart-check",
        label: "Purchased Items",
        value: "purchasedList",
        component: PurchasedList
    },
    {
        icon: 'bi bi-currency-dollar',
        label: 'Product Price',
        value: 'productProductPrice',
        component: ProductProductPrice
    }
];


const AnalyticsOptions = () => {
    return <OptionSelector options={options} initialOption="purchasedList" />
};

export default AnalyticsOptions;